// extracted by mini-css-extract-plugin
module.exports = {"sound-icon":"SoundIcon_sound-icon__4mfMN","sound-icon-column":"SoundIcon_sound-icon-column__fdKPZ","sound-icon-bar":"SoundIcon_sound-icon-bar__Wr60x"};